import { Box, Typography } from '@mui/material';
import classNames from 'classnames';
import { range } from 'lodash';
import { INFINITY_CAROUSEL_VIRTUAL_SLIDES_COUNT } from 'modules/leaderboards/constants';
import { CarouselContext } from 'shared/providers';
import React, { FC, useCallback, useContext, useMemo } from 'react';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useStyles } from './LeaderboardsCarouselHeader.styles';

interface LeaderboardsCarouselHeaderProps {
  slidesCount: number;
  isDotsPresent: boolean;
}

export const LeaderboardsCarouselHeader: FC<LeaderboardsCarouselHeaderProps> = ({
  slidesCount,
  isDotsPresent,
}) => {
  const { classes } = useStyles();
  const { activeSlide, setActiveSlide } = useContext(CarouselContext);

  const isActionsAllowed = useMemo(() => slidesCount > 1, [slidesCount]);

  const onClickHandler = useCallback(
    (event, slide: number) => {
      event.stopPropagation();

      if (!isActionsAllowed) {
        return;
      }

      setActiveSlide(slide + INFINITY_CAROUSEL_VIRTUAL_SLIDES_COUNT);
    },
    [isActionsAllowed, setActiveSlide]
  );

  return (
    <Box className={classes.root}>
      <Typography className={classes.title}>Leaderboards</Typography>
      {isDotsPresent && (
        <Box onClick={(event) => event.stopPropagation()}>
          {range(0, slidesCount).map((slide) => (
            <FiberManualRecordIcon
              key={slide}
              className={classNames(classes.indicator, {
                [classes.active]:
                  slide === activeSlide - INFINITY_CAROUSEL_VIRTUAL_SLIDES_COUNT ||
                  !isActionsAllowed,
              })}
              onClick={(event) => onClickHandler(event, slide)}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
